export default __webpack_public_path__ + "static/TransitionalDialog-8fee00b82470b8b206aa47e8bf227b81.gif";